import * as React from 'react';

export default (props:any) => (
    <svg
        viewBox='0 0 56 56'
        {...props}
    >
        <path
            d='M0 28C0 12.536 12.536 0 28 0s28 12.536 28 28-12.536 28-28 28S0 43.464 0 28zm28.609-10.956a3.043 3.043 0 100-6.087 3.043 3.043 0 000 6.087zm-6.696 2.434v2.435h3.652v17.043h-3.652v2.435h13.391v-2.434h-3.652V19.477h-9.739z'
        />
    </svg>
)
